<template>
  <v-container fluid>
    <ChannelSelect :current-module="this.$i18n.locale === 'en'? 'Posts' : 'Publicaciones'"/>
    <p v-if="this.$store.state.clubPosts.length === 0" class="text-center" style="margin-top: 30%">
      <v-btn v-if="this.$store.state.clubMember.rol !== 'MEMBER'" class="button-add mb-5 mt-n5" @click="overlayAddPost = true">
        {{ $t('btnAddFirst') }} <v-icon class="icon ml-2" color="white" small>fa-plus</v-icon></v-btn><br>
      {{ $t('noPosts') }}
    </p>

    <div v-else>
      <QuickPostBox v-if="this.$store.state.clubMember.rol !== 'MEMBER'"/>
      <v-timeline v-if="this.$store.state.clubPosts.length !== 0" dense>
        <v-timeline-item :color="`#${$store.state.clubMember.club.primaryColor}`" small v-bind:key="post.id"
                         v-for="post in this.$store.state.clubPosts">
          <v-card class="px-3 pt-2 pb-1">
            <p class="my-2" v-html="linkify(post.post)"></p>
            <p style="color: #777777; font-size: 14px;" class="d-flex text-start mb-1">
              {{ $t('postedOn') }} {{ monthNames[new Date(post.date).getMonth()] }} {{ new Date(post.date).getDate() }}/{{ new Date(post.date).getFullYear().toString() }}
              {{ String(new Date(post.date).getHours()).padStart(2, '0') }}:{{String(new Date(post.date).getMinutes()).padStart(2, '0')}} ・
              {{ $t('by') }}
              {{ (post.clubMember.user.id === $store.state.user.id) ? $t('me') : `${post.clubMember.user.firstName} ${post.clubMember.user.lastName}` }}
              <v-avatar v-if="post.clubMember.user.imageUrl != null" class="ml-2 mt-0" size="27">
                <v-img :src="post.clubMember.user.imageUrl" contain></v-img>
              </v-avatar>
              <v-spacer></v-spacer>
              <v-chip v-if="post.clubMember.user.id === $store.state.user.id" @click="deletePost(post)" class="mr-2"
                      small>
                <div style="font-size: 13px;" class="mb-0">{{ $t('btnDelete') }}
                  <v-icon class="icon ml-1" x-small>fa-trash</v-icon>
                </div>
              </v-chip>
            </p>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </div>

    <v-overlay v-model="overlayAddPost">
      <AddPost @closeWindow="overlayAddPost = false"/>
    </v-overlay>
    <v-overlay v-model="overlayDeletePost">
      <DeletePost :post="currentPost" @closeWindow="overlayDeletePost = false"/>
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
import DeletePost from "@/views/Community/components/DeletePost";
import QuickPostBox from "@/views/Community/components/QuickPostBox";
import AddPost from "@/views/Community/components/AddPost";
import ChannelSelect from "@/views/Community/components/ChannelSelect";
export default {
  name: "ClubDashboard",
  components: {ChannelSelect, AddPost, QuickPostBox, DeletePost},
  data() {
    return {
      monthNames: [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec')
      ],
      overlayAddPost: false,
      overlayDeletePost: false,
      currentPost: null,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    '$store.state.currentClubChannel': function () {
      this.init();
    },
  },
  methods: {
    ...mapMutations(['setClubPosts']),
    init() {
      Repository.getAllClubPostsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((response) => {
        if(response.status < 400)
          this.setClubPosts(response.data);
      });
    },
    linkify(inputText) {
      let replacedText, replacePattern1, replacePattern2;

      //URLs starting with http://, https://, or ftp://
      // eslint-disable-next-line no-useless-escape
      replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
      replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      // eslint-disable-next-line no-useless-escape
      replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
      return replacedText;
    },
    deletePost(post) {
      this.currentPost = post;
      this.overlayDeletePost = true;
    },
  },
}
</script>

<i18n>
{
  "en": {
    "btnAddFirst": "Create First Post",
    "months": {
      "jan" : "January",
      "feb" : "February",
      "mar" : "March",
      "apr" : "April",
      "may" : "May",
      "jun" : "June",
      "jul" : "July",
      "aug" : "August",
      "sep" : "September",
      "oct" : "October",
      "nov" : "November",
      "dec" : "December"
    },
    "postedOn": "Posted on",
    "by": "By",
    "me": "me",
    "btnDelete": "Delete Post",
    "noPosts": "There's no post yet in this channel :("
  },
  "es": {
    "btnAddFirst": "Crear Primera Publicación",
    "months": {
      "jan" : "Enero",
      "feb" : "Febrero",
      "mar" : "Marzo",
      "apr" : "Abril",
      "may" : "Mayo",
      "jun" : "Junio",
      "jul" : "Julio",
      "aug" : "Agosto",
      "sep" : "Septiembre",
      "oct" : "Octubre",
      "nov" : "Noviembre",
      "dec" : "Diciembre"
    },
    "postedOn": "Publicado en",
    "by": "Por",
    "me": "mí",
    "btnDelete": "Eliminar",
    "noPosts": "Aún no hay publicaciones en este canal :("
  }
}
</i18n>

<style scoped>
  .button-add {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }
</style>
